export default {"src":"/_next/static/media/ic_time.323d7f15.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};